<script lang="ts">
  import { EmptyState, ListNavigationItem } from "$components";
  import { type PaymentCard } from "$apis/parkito2";
  type Props = {
    cards: PaymentCard[];
    onSetDefault: (cardId: string) => Promise<unknown>;
    onRemoveCard: (cardId: string) => Promise<unknown>;
  };

  const { cards, onSetDefault, onRemoveCard }: Props = $props();
  function getCardImg(
    type: "visa" | "mastercard" | "amex" | string,
  ): string | undefined {
    switch (type) {
      case "visa":
        return "/icons/cards/visa.svg";
      case "mastercard":
        return "/icons/cards/mastercard.svg";
      case "amex":
        return "/icons/cards/amex.svg";
      default:
        return "/icons/cards/generic.svg";
    }
  }
</script>

<div>
  {#if cards.length === 0}
    <EmptyState
      title=""
      icon="/graphics/card.svg"
      message="Denna profil har inga kopplade kort"
    ></EmptyState>
  {/if}
  {#each cards as card, i}
    <ListNavigationItem
      title="∙∙∙∙ ∙∙∙∙ ∙∙∙∙ { card.last4 }"
      description={card.expiry.toString()}
      descriptionType={card.hasExpired ? "error" : undefined}
      labelRight={card.hasExpired
        ? "Ej giltigt"
        : card.isDefault
        ? "Valt betalkort"
        : "Välj som betalkort"}
      labelRightType={card.hasExpired ? "error" : card.isDefault ? "info" : "info"}
      onLabelRightClick={card.hasExpired || card.isDefault
        ? undefined
        : () => onSetDefault(card.id)}
      isFirst={i === 0}
      leftIconSrc={getCardImg(card.brand)}
      isLast={i === cards.length - 1}
      iconSrc="/icons/cross.svg"
      onIconClick={() => onRemoveCard(card.id)}
    />
  {/each}
</div>
